import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.719 3.842 3.178 9.595c-.237.18-.237.63 0 .81l7.541 5.753c.24.182.54-.044.54-.406V4.248c0-.362-.3-.588-.54-.406Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.46 3.842 8.92 9.595c-.238.18-.238.63 0 .81l7.54 5.753c.24.182.54-.044.54-.406V4.248c0-.362-.3-.588-.54-.406Z"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=RewindIcon20.js.map